import request from '@/utils/request'

// 二维码列表
export function qRCodeList(params = {}) {
  return request({
    url: '/scan/getScanContentList',
    method: 'get',
    params
  })
}

// 创建二维码
export function createQRCode(data = {}) {
  return request({
    url: '/scan/createScanContent',
    method: 'post',
    data
  })
}

// 二维码修改
export function qRCodeModification(data = {}) {
  return request({
    url: '/scan/updateScanContent',
    method: 'post',
    data
  })
}

// 二维码删除
export function qRCodeDeletion(data = {}) {
  return request({
    url: '/scan/delScanContent',
    method: 'post',
    data
  })
}

// 扫码手机列表
export function scanCodeMobilePhoneList(params = {}) {
  return request({
    url: '/scan/getScanPhoneList',
    method: 'get',
    params
  })
}

// 扫码手机创建
export function creationOfCodeScanningMobilePhone(data = {}) {
  return request({
    url: '/scan/createScanPhone',
    method: 'post',
    data
  })
}

// 扫码手机修改
export function modificationOfMobilePhoneScanningCode(data = {}) {
  return request({
    url: '/scan/updateScanPhone',
    method: 'post',
    data
  })
}

// 扫码手机删除
export function codeScanningMobilePhoneDeletion(data = {}) {
  return request({
    url: '/scan/delScanPhone',
    method: 'post',
    data
  })
}
// 手机关联企微-企业列表筛选
export function filterCorplist(params = {}) {
  return request({
    url: '/spWorkWechat/phoneRelation/filterCorp',
    method: 'get',
    params
  })
}
// 手机关联企微-企业员工筛选
export function filterUser(params = {}) {
  return request({
    url: '/spWorkWechat/phoneRelation/filterUser',
    method: 'get',
    params
  })
}
// 手机关联企微用户创建
export function phoneRelationstore(data = {}) {
  return request({
    url: '/spWorkWechat/phoneRelation/store',
    method: 'post',
    data
  })
}
// 手机关联企微用户列表
export function phoneRelationindex(params = {}) {
  return request({
    url: '/spWorkWechat/phoneRelation/index',
    method: 'get',
    params
  })
}
// 手机关联企微用户删除
export function phoneRelationstoredelte(data = {}) {
  return request({
    url: '/spWorkWechat/phoneRelation/destroy',
    method: 'post',
    data
  })
}
